/* ==========================================================================
   NUA DREAMS — buscador.js
   La lista que se va filtrando mientras se escribe en el cajón del buscador.

   Buscar no lo hace este archivo: lo hace Shopify, con su búsqueda predictiva.
   Aquí sólo se le pide, con el término escrito y el id de la sección
   sections/buscador-sugerencias.liquid, y se sustituye la lista por la que
   devuelve ya pintada. Por eso una búsqueda entiende plurales, tildes y
   sinónimos, y mira también en la descripción, el tipo y las etiquetas: eso es
   el buscador de la tienda, no un indexOf sobre seis nombres.

   El formulario funciona sin nada de esto: es un <form> contra /search y con
   Enter lleva a la página de resultados.

   Abrir y cerrar el cajón lo reparte cajones.js con data-accion.
   ========================================================================== */

(function () {

  var ESPERA = 250;          /* ms que se deja de escribir antes de preguntar */
  var SECCION = "buscador-sugerencias";

  var campo, caja, formulario;
  var inicial = "";          /* la lista de partida, la del campo vacío */
  var temporizador = null;
  var ultima = null;         /* la petición en curso, para poder abandonarla */

  /* Una búsqueda tarda menos que la siguiente tecla, así que sin esto llegan
     respuestas desordenadas y la lista acaba enseñando el resultado de «bro»
     cuando ya está escrito «brownie». AbortController corta la anterior en
     cuanto empieza otra. */
  function preguntar(consulta) {
    if (ultima) ultima.abort();
    ultima = new AbortController();

    var url = NuaSitio.rutas.sugerencias +
              "?q=" + encodeURIComponent(consulta) +
              "&resources[type]=product" +
              "&resources[limit]=8" +
              "&section_id=" + SECCION;

    return fetch(url, { signal: ultima.signal })
      .then(function (respuesta) {
        if (!respuesta.ok) throw new Error("busqueda");
        return respuesta.text();
      })
      .then(function (html) {
        var seccion = NuaSitio.seccion(html, "#shopify-section-" + SECCION);
        caja.innerHTML = seccion ? seccion.innerHTML : "";
        anunciar();
      })
      .catch(function (error) {
        /* Abandonar una petición no es un fallo: es lo que se quería. */
        if (error.name === "AbortError") return;
        caja.innerHTML = inicial;
      });
  }

  /* Lo que se anuncia viene escrito en la propia respuesta: el resumen si hay
     resultados, el aviso de «no hay nada» si no los hay. Ninguna de las dos
     frases se arma aquí. */
  function anunciar() {
    var frase = caja.querySelector("[data-buscador-resumen]") ||
                caja.querySelector(".buscador__aviso");
    if (frase) NuaSitio.anunciar(frase.textContent.trim());
  }

  function alEscribir() {
    var consulta = campo.value.trim();

    clearTimeout(temporizador);

    /* Con el campo vacío vuelve la lista de partida, que ya venía pintada con
       la página: no hay nada que preguntarle al servidor. */
    if (!consulta) {
      if (ultima) ultima.abort();
      caja.innerHTML = inicial;
      return;
    }

    temporizador = setTimeout(function () { preguntar(consulta); }, ESPERA);
  }

  function iniciar() {
    formulario = document.querySelector("[data-buscador-formulario]");
    campo = document.querySelector("[data-buscador-campo]");
    caja = document.querySelector("[data-buscador-resultados]");
    if (!formulario || !campo || !caja) return;

    inicial = caja.innerHTML;

    campo.addEventListener("input", alEscribir);

    /* Escape con el campo escrito lo vacía en vez de cerrar el cajón: es lo que
       espera quien se ha equivocado de palabra. Sólo cuando ya está vacío deja
       pasar el Escape a cajones.js, que entonces sí cierra. */
    campo.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape" && campo.value !== "") {
        ev.stopPropagation();
        campo.value = "";
        alEscribir();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
})();
